import { above } from '@fogia/core-web/utils/mediaqueries';

export const richTextTagStyles = `
    > div {
        display: flex;
        flex-direction: column;
    }

    > * {
        margin: 0;
    }

    h1 {
        margin-top: 40px;
        margin-bottom: 0;

        ${above['tablet.lg']} {
            margin-top: 50px;
        }
    }

    h2,
    h3,
    h4,
    h5,
    h6 {
        margin-top: 10px;
        margin-bottom: 0;
    }

    h2 {
        font-size: 18px;
        line-height: 120%;
        letter-spacing: -0.03em;

        ${above['tablet.lg']} {
            font-size: 24px;
            line-height: 110%;
            letter-spacing: -0.03em;
        }
    }

    ul,
    ol {
        margin-top: 20px;
        margin-bottom: 20px;
    }

    h1 + p,
    h2 + p,
    h3 + p,
    h4 + p,
    h5 + p,
    h6 + p,
    p + p {
        text-indent: 30px;
    }

    p {
        margin-bottom: 0;
    }

    ol,
    ul {
        padding: 0;

        li + li {
            margin-top: 5px;
        }
    }

    /* Typography on li so bullet offset (em) tracks 13px / 15px list text. */
    ol li,
    ul li {
        display: flex;
        font-family: 'ABC Monument Grotesk Variable', 'ABC Monument Grotesk Variable Fallback';
        font-size: 13px;
        line-height: 120%;
        letter-spacing: -0.01em;
        font-weight: 510;

        ${above['tablet.lg']} {
            font-size: 15px;
        }

        p {
            text-indent: 0;
            font-family: inherit;
            font-size: inherit;
            line-height: inherit;
            letter-spacing: inherit;
            font-weight: inherit;
            margin-bottom: 0;
            flex: 1;
            min-width: 0;
        }
    }

    ol li {
        align-items: baseline;
    }

    ul {
        list-style: none;

        li {
            align-items: flex-start;
            column-gap: 11px;

            &::before {
                content: '';
                width: 5px;
                height: 5px;
                min-width: 5px;
                border-radius: 50%;
                background-color: var(--color-base-brickwork-orange, #e64b28);
                flex-shrink: 0;
                /* em scales with list font size; 0.65em ≈ half the line box at 120% line-height; minus half the dot in px (fixed-size marker) */
                margin-top: calc(0.65em - 2.5px);
            }
        }
    }

    ol {
        counter-reset: item 0;
        li {
            counter-increment: item;
            &::before {
                min-width: 16px;
                content: counter(item) '.';
                display: inline-block;
                color: var(--color-base-brickwork-orange, #e64b28);
                text-indent: 0;
                font-family: 'ABC Monument Grotesk Variable', 'ABC Monument Grotesk Variable Fallback';
                font-size: 13px;
                line-height: 120%;
                letter-spacing: -0.01em;
                font-weight: 510;
                margin-bottom: 0;
                white-space: nowrap;

                ${above['tablet.lg']} {
                    font-size: 15px;
                }
            }
        }
    }

    *:first-child {
        margin-top: 0;
    }
`;
